import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'cards.error.title',
        defaultMessage: 'Unable to load card products',
    },
    description: {
        id: 'cards.error.description',
        defaultMessage: 'Please check your internet connection and try again',
    },
    button: {
        id: 'cards.error.button',
        defaultMessage: 'Reload',
    },
})
